/* unplugin-vue-components disabled */import { render } from "./TitlePopUp.vue?vue&type=template&id=66dd83c9&scoped=true&ts=true"
import script from "./TitlePopUp.vue?vue&type=script&lang=ts"
export * from "./TitlePopUp.vue?vue&type=script&lang=ts"

import "./TitlePopUp.vue?vue&type=style&index=0&id=66dd83c9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66dd83c9"]])

export default __exports__